import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { reactive, ref } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { publicCustomerAllotRegion } from '@/api/gucangSales/customerCenter'
import type { SalesClueListItem } from '@/typings/api/clueManage'


const __default__ = { name: 'CustomerAllotRegion' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ customerRegion: string; cosIdList: any[] }>({ customerRegion: '', cosIdList: [] })
const formRules = reactive({
  customerRegion: [{ required: true, message: '请选择客户区域' }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = __emit
const handleOk = () => {
  validate().then(() => {
    loading.value = true
    dataForm.cosIdList = selectedData.value.map((item: SalesClueListItem) => item.cosId)
    const params = Object.assign({}, dataForm)
    publicCustomerAllotRegion(params)
      .then(() => {
        emit('fetch', dataForm.customerRegion)
        DcMessage.success('分配客户区域成功')
        resetFields()
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  resetFields()
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "分配区域",
    "body-style": { padding: '30px' },
    "confirm-loading": loading.value,
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, { "wrapper-col": { span: 24 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, _mergeProps({ label: "客户区域" }, _unref(validateInfos).customerRegion), {
            default: _withCtx(() => [
              _createVNode(CustomerAreaCascader, {
                appId: "cos_fbu",
                value: dataForm.customerRegion,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.customerRegion) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})